// WorkOS-Rollen-Slugs: eine Quelle fuer Berechtigungspruefung (Backend) und Anzeige (Web/Mobile).

export type OrgRole = 'member' | 'president';

/** Slugs mit erweiterten Rechten im Backend (Vergleich ohne Gross-/Kleinschreibung). */
export const PRIVILEGED_ROLE_SLUGS: readonly string[] = ['president', 'praesident', 'präsident'];

export const ROLE_LABELS: Record<OrgRole, string> = {
  president: 'Präsident',
  member: 'Mitglied',
};

function normalizeSlug(slug: string | null | undefined): string {
  return (slug ?? '').normalize('NFC').trim().toLowerCase();
}

/** true fuer Praesidenten-Rollen; entspricht der Autorisierung im Backend. */
export function isPrivilegedRoleSlug(slug: string | null | undefined): boolean {
  return PRIVILEGED_ROLE_SLUGS.includes(normalizeSlug(slug));
}

/**
 * Rolle fuer Rollenwechsel und Einladungen. Der WorkOS-Standardslug 'admin' gilt als Praesident,
 * damit ein Bearbeiten den Admin nie stillschweigend zum Mitglied herabstuft.
 */
export function normalizeRoleSlug(slug: string | null | undefined): OrgRole {
  const normalized = normalizeSlug(slug);
  return normalized === 'admin' || isPrivilegedRoleSlug(normalized) ? 'president' : 'member';
}

/** Anzeigename einer Rolle; unbekannte Slugs werden unveraendert angezeigt. */
export function getRoleLabel(slug: string | null | undefined): string {
  const normalized = normalizeSlug(slug);
  if (isPrivilegedRoleSlug(normalized)) return ROLE_LABELS.president;
  if (normalized === 'admin') return 'Administrator';
  if (!normalized || normalized === 'member') return ROLE_LABELS.member;
  return (slug ?? '').trim();
}
